import { FC } from 'react'
import NotFoundBase, { Props } from '@client-hub/shared/react/components/NotFoundBase'

const HubNotFound: FC<Props> = ({ returnToHomeLink }) => <NotFoundBase returnToHomeLink={returnToHomeLink} />

export default HubNotFound
